var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:{
    'red--text': _vm.isNegative,
    'green--text': _vm.isPositive,
  }},[(!_vm.hidePlusSign && _vm.value && _vm.value > 0)?_c('span',{staticClass:"font-size-75"},[_vm._v(" +")]):_vm._e(),(_vm.value == null)?_c('span',[_vm._v("-")]):_c('span',[_vm._v(_vm._s(_vm._f("num")(_vm.value,_vm.fractionalDigits)))])])}
var staticRenderFns = []

export { render, staticRenderFns }